<template>
  <div :class="['text-input',classField]">
    <label :for="'text-'+uuid" class="subtitle-2 black--text pl-3">
      {{field.label}}
      <span v-if="this.field.required==1" class="orange--text text--darken-3">*</span>
    </label>
    <v-autocomplete
      v-model="model"
      @change="update()"
      :placeholder="field.config.placeholder"
      :error-messages="errorMessages"
      class="pt-1"
      :items="items"
      :loading="isLoading"
      :search-input.sync="search"
      clearable
      no-filter
    >
      <template slot="no-data">
        <v-list-item>
          <v-list-item-title>
            Search for a
            <strong>Place</strong>
          </v-list-item-title>
        </v-list-item>
      </template>
      <template slot="selection" slot-scope="{ item, selected }">
        <v-chip :input-value="selected" color="blue-grey" class="white--text">
          <v-icon left>mdi-map-marker</v-icon>
          <span v-text="item.text"></span>
        </v-chip>
      </template>
      <template slot="item" slot-scope="{ item }">
        <v-list-item-avatar
          color="indigo"
          class="headline font-weight-light white--text"
        >{{ item.text.charAt(0) }}</v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-text="item.text"></v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon>mdi-map-marker</v-icon>
        </v-list-item-action>
      </template>
    </v-autocomplete>
    <div class="errorMsg" v-if="block.errorMessages">{{block.errorMessages[0]}}</div>
    <div class="hint" v-if="field.hint">{{field.hint}}</div>
  </div>
</template>

<script>
import FieldMixin from "./FieldMixin";

import gplaceInit from "../../../utils/google.place";

export default {
  mixins: [FieldMixin],
  name: "FieldGooglemap",
  data: () => ({
    search: null,
    google: null,
    items: [],
    isLoading: false
  }),
  async mounted() {
    try {
      this.google = await gplaceInit();
    } catch (error) {
      console.error(error);
    }
    this.search = this.model;
  },
  watch: {
    search(val) {
      if (!val) {
        return;
      }

      this.isLoading = true;

      const service = new this.google.maps.places.AutocompleteService();
      service.getQueryPredictions({ input: val }, (predictions, status) => {
        if (status != this.google.maps.places.PlacesServiceStatus.OK) {
          return;
        }

        this.items = predictions.map(prediction => {
          return {
            value: prediction.description,
            text: prediction.description
          };
        });

        this.isLoading = false;
      });
    }
  },

  methods: {
    validate: function() {
      this.errorMessages = [];
      if (this.field.required === 1 && !this.model) {
        this.isValid = false;
        this.addError(this.block.id,"Champ obligatoire");

      } else {
        this.isValid = true;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.text-input {
  /deep/ .v-text-field__slot {
    border-color: #e8e8e8;
    background-color: #e8e8e8;
  }
  /deep/ .v-text-field input {
    padding: 3px 0;
  }
}
</style>
